import axios from "axios";
import store from "../store";
import state from "@/store";

const baseURL = store.getters.mainAppURL + "orders/";
const getRestaurantCancelledOrders = (params) => axios.post(baseURL +"get_restaurant_cancelled_orders", params);
const getOrderDetailsByCallerNumber = (caller_number) => axios.post(baseURL + "get_order_by_caller_number/" + caller_number);
const getOrderPaymentStatuses = () => axios.get(state.getters.mainAppURL + "orders/get_all_payment_statuses");
const saveFoodPandaOrderDetails = (params) => axios.post(baseURL + "foodpanda_details", params );
const exportOrders = (params) => axios.post(store.getters.mainAppURL + "export_orders", params );
const updateCustomDeliveryFeeAndLoyaltyPoints = (params) => axios.post(baseURL + "update_order_custom_delivery_fee_and_loyalty_points", params);

export {
    getRestaurantCancelledOrders,
    getOrderDetailsByCallerNumber,
    getOrderPaymentStatuses,
    saveFoodPandaOrderDetails,
    exportOrders,
    updateCustomDeliveryFeeAndLoyaltyPoints
}


